import React from "react";
import { LoadingOutlined } from "@ant-design/icons";

const AppButton = ({
  children,
  variant = "primary",
  size = "md",
  disabled = false,
  onClick,
  className = "",
  icon,
  loading = false,
  ...restProps
}) => {
  const baseStyles =
    "inline-flex items-center justify-center whitespace-nowrap font-medium rounded-xl transition-all duration-200 ";

  const variants = {
    primary: "bg-primary text-white hover:opacity-80 ",
    primaryOutline: "border border-primary text-primary hover:bg-primary hover:text-white focus:ring-primary",
    secondary: "bg-gray-100 text-gray-800 hover:bg-gray-200 focus:ring-gray-400",
    outline: "border border-gray-300 text-gray-700 hover:bg-gray-100 focus:ring-gray-400",
    danger: "bg-red-600 text-white hover:bg-red-700 focus:ring-red-500",
    dangerOutline: "border border-red-600 text-red-600 hover:bg-red-50 hover:text-white focus:ring-red-500",
  };

  const sizes = {
    sm: "px-3 py-3 text-sm",
    md: "px-4 py-3 text-sm",
    lg: "px-6 py-3 text-base",
  };

  const disabledStyles = disabled ? "opacity-50 cursor-not-allowed" : "";

  return (
    <button
      disabled={disabled}
      onClick={onClick}
      className={`app-button-custom flex gap-2 ${baseStyles} ${variants[variant]} ${sizes[size]} ${disabledStyles} ${className} self-end`}
      {...restProps}

    >
      {loading && <LoadingOutlined />}
      {icon}
      {children}
    </button>
  );
};

export default AppButton;

